export interface DataTypeConstraintDto {
    id: string;
    name: string;
    description?: string;
    constraintData: ConstraintDataDto;
    acl?: DataTypeConstraintAclDto;
}

export interface DataTypeConstraintAclDto {
    canUpdate: boolean;
    canDelete: boolean;
}

export interface DataTypeConstraintCreateDto {
    name: string;
    description?: string;
    constraintData: ConstraintDataDto;
}

export type ConstraintDataDto = CurrencyRangeConstraintDataDto
    | DateRangeConstraintDataDto
    | DateTimeRangeConstraintDataDto
    | EnumerationConstraintDataDto
    | FloatRangeConstraintDataDto
    | IntegerRangeConstraintDataDto
    | RegExConstraintDataDto
    | StringLengthRangeConstraintDataDto
    | TimeRangeConstraintDataDto;

export enum ConstraintType {
    CURRENCY_RANGE = "CurrencyRangeConstraint",
    DATE_RANGE = "DateRangeConstraint",
    DATE_TIME_RANGE = "DateTimeRangeConstraint",
    ENUMERATION = "EnumerationConstraint",
    FLOAT_RANGE = "FloatRangeConstraint",
    INTEGER_RANGE = "IntegerRangeConstraint",
    REGULAR_EXPRESSION = "RegExConstraint",
    STRING_LENGTH_RANGE = "StringLengthRangeConstraint",
    TIME_RANGE = "TimeRangeConstraint",
}

export interface CurrencyRangeConstraintDataDto {
    type: ConstraintType.CURRENCY_RANGE;
    min?: number;
    max?: number;
}

export interface DateRangeConstraintDataDto {
    type: ConstraintType.DATE_RANGE;
    dateFrom?: string | null;
    dateTo?: string | null;
}

export type OffsetDateTimeString = `${number}-${number}-${number}T${number}:${number}:${number}${'+' | '-'}${number}:${number}`;

export interface DateTimeRangeConstraintDataDto {
    type: ConstraintType.DATE_TIME_RANGE;
    dateTimeFrom?: OffsetDateTimeString | null;
    dateTimeTo?: OffsetDateTimeString | null;
}

export interface EnumerationConstraintDataDto {
    type: ConstraintType.ENUMERATION;
    values: string[];
}

export interface IntegerRangeConstraintDataDto {
    type: ConstraintType.INTEGER_RANGE;
    min?: number;
    max?: number;
}

export interface FloatRangeConstraintDataDto {
    type: ConstraintType.FLOAT_RANGE;
    min?: number;
    max?: number;
}

export interface RegExConstraintDataDto {
    type: ConstraintType.REGULAR_EXPRESSION;
    regEx: string;
}

export interface StringLengthRangeConstraintDataDto {
    type: ConstraintType.STRING_LENGTH_RANGE;
    min?: number;
    max?: number;
}

export interface TimeRangeConstraintDataDto {
    type: ConstraintType.TIME_RANGE;
    timeFrom?: string | null;
    timeTo?: string | null;
}
